// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"9126ed15","72":"f9bd8b58","362":"10207b90","386":"2cdfa01c","413":"8dc0ed12","466":"ab82e92a","488":"6e4a5fb9","494":"ffd72312","505":"6abc3a27","605":"6a84ad15","858":"27aa3f02"}[chunkId] + ".chunk.js";
};